export const BASIC_TOUT_CONTENT_NID = 242714;
export const BASIC_TOUT = 'basic-tout';
